import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  ApiRouterGuard,
  AuthorizationBaseService,
  AuthorizationService,
} from '@twino/core-lib';
import { HalvoApplicationLayoutComponent } from '../components/halvo-application-layout/halvo-application-layout.component';

const appRoutes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },

  {
    path: '',
    component: HalvoApplicationLayoutComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import(
            '../../../../../libs/commons/authentication/authentication.module'
          ).then((mod) => mod.AuthenticationModule),
      },
      {
        path: 'application',
        loadChildren: () =>
          import(
            '../../../../../libs/commons/application/application.module'
          ).then((mod) => mod.ApplicationModule),
        data: {
          productSubType: 'NEW',
        },
      },
      {
        path: 'status',
        loadChildren: () =>
          import('../../../../../libs/commons/status/status.module').then(
            (mod) => mod.StatusModule
          ),
      },
      {
        path: 'incorrect-login',
        redirectTo: 'status/incorrect-login',
      },
      {
        path: 'repeated-application',
        canActivate: [ApiRouterGuard],
        loadChildren: () =>
          import(
            '../../../../../libs/commons/repeated-application/repeated-application.module'
          ).then((m) => m.RepeatedApplicationModule),
        data: {
          productSubType: 'REPEATED',
        },
      },
      {
        path: 'test',
        loadChildren: () =>
          import(
            '../../../../netcard-pl/src/app/modules/test/test.module'
          ).then((mod) => mod.TestModule),
      },
      {
        path: 'legacy',
        canActivate: [ApiRouterGuard],
        loadChildren: () =>
          import('../../../../../libs/commons/legacy/legacy.module').then(
            (m) => m.LegacyModule
          ),
      },
    ],
  },
  {
    path: 'api-router',
    canActivate: [ApiRouterGuard],
    children: [],
  },
  {
    path: 'identification',
    loadChildren: () =>
      import(
        '../../../../../libs/commons/identification/identification.module'
      ).then((m) => m.IdentificationModule),
  },
  {
    path: 'profile',
    canActivate: [ApiRouterGuard],
    loadChildren: () =>
      import('../../../../../libs/commons/profile/profile.module').then(
        (m) => m.ProfileModule
      ),
  },
];

const routes: Routes = [
  {
    path: 'mobile',
    children: [...appRoutes],
  },
  ...appRoutes,
];

@NgModule({
  declarations: [],
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabledBlocking',
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
    }),
  ],
  exports: [RouterModule],
  providers: [
    { provide: AuthorizationBaseService, useExisting: AuthorizationService },
  ],
})
export class RoutesModule {}
